export default {
  title: "Countries",
  subtitle: "Manage countries and regions",
  
  // Actions
  addNew: "Add New Country",
  createCountry: "Create Country",
  editCountry: "Edit Country",
  deleteCountry: "Delete Country",

  actions: {
    back: "Back",
    update: "Update",
    updating: "Updating...",
    save: "Save",
    saving: "Saving...",
    cancel: "Cancel",
    edit: "Edit",
    delete: "Delete"
  },
  
  // Fields
  fields: {
    name: "Country Name",
    code: "Country Code",
    iso2: "ISO2 Code",
    iso3: "ISO3 Code",
    phoneCode: "Phone Code",
    phoneRegularExpression: "Phone Regular Expression",
    currency: "Currency",
    region: "Region",
    subregion: "Subregion",
    capital: "Capital",
    flag: "Flag",
    status: "Status",
    type: "Country Type",
    symbol: "Symbol",
    warehouseAddress: "Warehouse Address",
    warehouseAddressLine1: "Warehouse Address Line 1",
    warehouseAddressLine2: "Warehouse Address Line 2",
    warehouseCity: "Warehouse City",
    warehousePostalCode: "Warehouse Postal Code",
    warehousePhone: "Warehouse Phone",
    isActive: "Warehouse Status",
    isSuspended: "Suspended Status",
    createdAt: "Created At",
    updatedAt: "Updated At"
  },
  
  // Placeholders
  placeholders: {
    name: "Enter country name",
    code: "Enter country code",
    iso2: "Enter ISO2 code (e.g., US)",
    iso3: "Enter ISO3 code (e.g., USA)",
    phoneCode: "Enter phone code (e.g., +1)",
    phoneRegularExpression: "Enter regex pattern (e.g., ^[0-9]{10}$)",
    currency: "Enter currency code (e.g., USD)",
    region: "Enter region",
    subregion: "Enter subregion",
    capital: "Enter capital city",
    flag: "Enter flag emoji or URL",
    symbol: "Enter country symbol",
    warehouseAddress: "Enter warehouse address",
    warehouseAddressLine1: "Enter warehouse address line 1 (optional)",
    warehouseAddressLine2: "Enter warehouse address line 2 (optional)",
    warehouseCity: "Enter warehouse city name (optional)",
    warehousePostalCode: "Enter warehouse postal code (optional)",
    warehousePhone: "Enter warehouse phone number (optional)"
  },
  
  // Messages
  messages: {
    createSuccess: "Country created successfully",
    createError: "Failed to create country",
    updateSuccess: "Country updated successfully",
    updateError: "Failed to update country",
    deleteSuccess: "Country deleted successfully",
    deleteError: "Failed to delete country",
    deleteConfirm: "Are you sure you want to delete this country?",
    noCountries: "No countries found",
    loadingCountries: "Loading countries...",
    fetchError: "Failed to fetch countries"
  },
  
  // Validation
  validation: {
    nameRequired: "Country name is required",
    nameMinLength: "Country name must be at least 2 characters",
    nameMaxLength: "Country name must not exceed 100 characters",
    codeRequired: "Country code is required",
    codeFormat: "Country code must be 2-3 characters",
    iso2Required: "ISO2 code is required",
    iso2Format: "ISO2 code must be exactly 2 characters",
    iso3Format: "ISO3 code must be exactly 3 characters",
    phoneCodeFormat: "Phone code must start with + and contain only numbers",
    currencyFormat: "Currency code must be 3 characters (e.g., USD)",
    capitalMaxLength: "Capital name must not exceed 100 characters",
    symbolRequired: "Symbol is required",
    currencyRequired: "Currency is required",
    warehouseAddressRequired: "Warehouse address is required",
    fillAllFields: "Please fill in all required fields"
  },
  
  // Table headers
  table: {
    name: "Name",
    code: "Code",
    iso2: "ISO2",
    iso3: "ISO3",
    phoneCode: "Phone Code",
    currency: "Currency",
    region: "Region",
    capital: "Capital",
    flag: "Flag",
    status: "Status",
    suspended: "Suspended",
    type: "Type",
    symbol: "Symbol",
    actions: "Actions"
  },
  
  // Status options
  status: {
    active: "Active",
    inactive: "Inactive",
    suspended: "Suspended",
    notSuspended: "Not Suspended"
  },

  // Country types
  types: {
    both: "Both",
    destination: "Destination",
    source: "Source",
    notSet: "Not Set"
  },
  
  // Regions
  regions: {
    africa: "Africa",
    americas: "Americas",
    asia: "Asia",
    europe: "Europe",
    oceania: "Oceania",
    antarctica: "Antarctica"
  },
  
  // Breadcrumbs
  breadcrumbs: {
    countries: "Countries",
    create: "Create Country",
    edit: "Edit Country",
    view: "View Country"
  }
};
